// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import dataTableStyles from "@conklin/App/SharedStyles/MyAccountPages/List/DataTableStyles";
import IconReorder from "@conklin/XDL/Icons/IconReorder";
import { ellipsis, iconButtonCommonStyles, xScreen } from "@conklin/XDL/Utilities";
import { orderHistoryTableStyles } from "@insite/content-library/Widgets/OrderHistory/OrderHistoryTable";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

orderHistoryTableStyles.reorderButton = {
    ...iconButtonCommonStyles(IconReorder, 12, {}, "common.ui9"),
};

orderHistoryTableStyles.reorderButtonSpinner = {
    size: 15,
    css: css`
        display: block;
    `,
};

orderHistoryTableStyles.noResultsContainer = {
    ...dataTableStyles.noResultsContainer,
};

orderHistoryTableStyles.noResultsText = {
    ...dataTableStyles.noResultsText,
};

orderHistoryTableStyles.orderNumberHeader = {
    tight: true,
};

orderHistoryTableStyles.orderDateHeader = {
    tight: true,
};

orderHistoryTableStyles.statusHeader = {
    tight: true,
};

orderHistoryTableStyles.customerPOHeader = {
    tight: true,
};

orderHistoryTableStyles.reorderHeader = {
    tight: true,
};

orderHistoryTableStyles.shipToHeader = {
    tight: true,
};

orderHistoryTableStyles.orderTotalHeader = {
    tight: true,
};

orderHistoryTableStyles.shipToCells = {
    css: css`
        display: block;
        max-width: 450px;
        min-width: 250px;
        white-space: normal;
        > ${TypographyStyle} {
            ${ellipsis(1)}
        }
    `,
};

orderHistoryTableStyles.orderTotalCells = {
    alignX: "left",
};

orderHistoryTableStyles.reorderCells = {
    css: css`
        align-items: center;
    `,
};

orderHistoryTableStyles.dataTable = {
    css: css`
        ${xScreen("lte", 767)} {
            [data-test-selector="orderHistoryTable_tableCell_shipTo"] [class^="ValueTypography"] {
                white-space: normal;
                ${ellipsis(3)}
            }
        }
    `,
};
